import { FINAL_ROUND_SECONDS } from "../lib/game-state";

interface GameTimerBarProps {
  timeLeft: number;
}

export function GameTimerBar({ timeLeft }: GameTimerBarProps) {
  const pct = Math.max(0, Math.min(100, (timeLeft / FINAL_ROUND_SECONDS) * 100));
  const urgent = timeLeft <= 10;

  return (
    <div
      className={`act-gametimer act-gametimer--final${urgent ? " act-gametimer--urgent" : ""}`}
      role="timer"
      aria-live="polite"
      aria-label={`${timeLeft} seconden resterend`}
    >
      <div className="act-gametimer__track">
        <div
          className="act-gametimer__fill"
          style={{ width: `${pct}%` }}
        />
        <span className="act-gametimer__label">
          <span className="act-gametimer__seconds">{timeLeft}</span>
          <span className="act-gametimer__unit">s</span>
        </span>
      </div>
    </div>
  );
}
